goog.provide("shadow.js.shim.module$ol$layer$Vector");
goog.provide("module$shadow_js_shim_module$ol$layer$Vector");
shadow.js.shim.module$ol$layer$Vector = shadow.js.nativeProvides["ol/layer/Vector"] = shadow$bridge("ol/layer/Vector");
module$shadow_js_shim_module$ol$layer$Vector.default = shadow.js.shim.module$ol$layer$Vector;
